export const AndroidDevelopment = [
    {
      question: "What is Android?",
      option1: "A programming language",
      option2: "An operating system for mobile devices",
      option3: "A web browser",
      option4: "A database management system",
      ans: 2,
    },
    {
      question: "Which programming language is primarily used for Android development?",
      option1: "JavaScript",
      option2: "Python",
      option3: "Java",
      option4: "Ruby",
      ans: 3,
    },
    {
      question: "What is an Activity in Android?",
      option1: "A single screen with a user interface",
      option2: "A background service",
      option3: "A database table",
      option4: "A type of intent",
      ans: 1,
    },
    {
      question: "What is the purpose of an Intent in Android?",
      option1: "To display a new screen",
      option2: "To communicate between components",
      option3: "To manage user input",
      option4: "To handle database operations",
      ans: 2,
    },
    {
      question: "Which XML file is used to define the UI layout in Android?",
      option1: "activity_main.xml",
      option2: "strings.xml",
      option3: "colors.xml",
      option4: "styles.xml",
      ans: 1,
    },
    {
      question: "How do you start a new Activity in Android?",
      option1: "Using startActivity() method",
      option2: "Using startService() method",
      option3: "Using startIntent() method",
      option4: "Using startBroadcast() method",
      ans: 1,
    },
    {
      question: "What is a Fragment in Android?",
      option1: "A reusable portion of the UI",
      option2: "A type of service",
      option3: "A type of broadcast receiver",
      option4: "A type of content provider",
      ans: 1,
    },
    {
      question: "Which layout arranges elements in a single column or row?",
      option1: "LinearLayout",
      option2: "RelativeLayout",
      option3: "FrameLayout",
      option4: "ConstraintLayout",
      ans: 1,
    },
    {
      question: "What is the AndroidManifest.xml file used for?",
      option1: "To define application permissions and components",
      option2: "To define UI layouts",
      option3: "To define resource values",
      option4: "To define user settings",
      ans: 1,
    },
    {
      question: "What is Gradle in Android development?",
      option1: "A testing framework",
      option2: "A build automation tool",
      option3: "A database management system",
      option4: "A user interface design tool",
      ans: 2,
    },
  ];
  